/**
 * Zwraca tylko elementy tablic, które znajdują sie w obu tablicach
 *
 * @export
 * @param {[]} arr1
 * @param {[]} arr2
 * @param {(a: any, b: any) => boolean} [compareFunc]
 * @returns {[]}
 */
export function intersection(arr1: [], arr2: [], compareFunc?: (a: any, b: any) => boolean): [] {
  const res: [] = [];
  for (let i = 0; i < arr1.length; i++) {
    if (compareFunc) {
      if (!arr2.find(value => compareFunc(arr1[i], value))) {
        continue;
      }
    } else if (!arr2.includes(arr1[i])) {
      continue;
    }
    res.push(arr1[i]);
  }
  return res;
}

//@ts-ignore
export function intersectMany(...arrs): [] {
  let res = arrs[0].slice();
  for (let i = 1; i < arrs.length; i++) {
    res = intersection(res, arrs[i]);
  }
  return res;
}
